import http from "../http-common";

const getAll = () => {
  return http.get<Array<any>>(`/prospect-customer-campaign`);
};

const get = (id: any) => {
  return http.get<Array<any>>(`/prospect-customer-campaign/${id}`);
};

const create = (data: any) => {
  return http.post<any>("/prospect-customer-campaign", data);
};

const update = (id: any, data: any) => {
  return http.put<any>(`/prospect-customer-campaign/${id}`, data);
};

const remove = (id: any) => {
  return http.delete<any>(`/prospect-customer-campaign/${id}`);
};

const ProspectCustomerCampaignsService = {
  getAll,
  get,
  create,
  update,
  remove,
};

export default ProspectCustomerCampaignsService;
